import { useTranslation } from '@kostbar/i18n'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { Badge } from '@/components/ui/badge'
import { Skeleton } from '@/components/ui/skeleton'
import { useOverview } from '@/features/dashboard/hooks/use-overview'
import { formatRelativeTime } from '@/shared/utils/format-date'

export function BundleStatus() {
  const { t: tBundles } = useTranslation('bundles')
  const { t: tCommon } = useTranslation('common')
  const { data, isLoading, error } = useOverview()

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>{tBundles('status.title')}</CardTitle>
          <CardDescription>{tBundles('status.description')}</CardDescription>
        </CardHeader>
        <CardContent>
          <Skeleton className="h-32 w-full" />
        </CardContent>
      </Card>
    )
  }

  if (error) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>{tBundles('status.title')}</CardTitle>
          <CardDescription>{tBundles('status.description')}</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">
            {tBundles('status.loadFailed')}
          </p>
        </CardContent>
      </Card>
    )
  }

  const bundleVersions = data?.bundleVersions || []

  if (bundleVersions.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>{tBundles('status.title')}</CardTitle>
          <CardDescription>{tBundles('status.description')}</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">
            {tBundles('status.empty')}
          </p>
        </CardContent>
      </Card>
    )
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>{tBundles('status.title')}</CardTitle>
        <CardDescription>{tBundles('status.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>{tBundles('status.tableRestaurant')}</TableHead>
              <TableHead>{tBundles('status.tableVersion')}</TableHead>
              <TableHead>{tBundles('status.tablePublished')}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {bundleVersions.map((bundle) => (
              <TableRow key={bundle.restaurantId}>
                <TableCell className="font-medium">
                  {bundle.restaurantName}
                </TableCell>
                <TableCell>
                  {bundle.latestVersion !== null ? (
                    <Badge variant="secondary">
                      {tCommon('versionPrefix')}
                      {bundle.latestVersion}
                    </Badge>
                  ) : (
                    <span className="text-muted-foreground text-sm">—</span>
                  )}
                </TableCell>
                <TableCell className="text-sm text-muted-foreground">
                  {bundle.publishedAt
                    ? formatRelativeTime(bundle.publishedAt)
                    : '—'}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  )
}
